module.exports = __webpack_public_path__ + "static/media/vip_ring.387c5b84.svg";